module.exports = __webpack_public_path__ + "static/media/25_ManuelGalemann_webfinal.8a0be10a.jpg";